module.exports = __webpack_public_path__ + "static/media/weight-icon.3e08b6a0.svg";